module.exports = __webpack_public_path__ + "static/img/20003 (3).c6ab6d8.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20003 (3).webp
// module id = FBud
// module chunks = 14